import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export default function SearchInput({
  searchText,
  setSearchText,
  sx,
  handleFilter,
  additionalParams = []
}: {
  searchText: string
  setSearchText: Dispatch<SetStateAction<string>>
  sx?: any
  handleFilter?: (searchValue: string, ...additionalParams: string[]) => void
  additionalParams?: string[]
}) {
  const { t } = useTranslation()
  const [localValue, setLocalValue] = useState(searchText)

  // Debounce search text
  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearchText(localValue)
    }, 300)

    return () => clearTimeout(timeout)
  }, [localValue, setSearchText])

  useEffect(() => {
    setLocalValue(searchText)
  }, [searchText])

  const handleClear = () => {
    setLocalValue('')
    setSearchText('')

    if (handleFilter) {
      handleFilter('', ...additionalParams)
    }
  }

  return (
    <TextField
      placeholder={t('common.search')}
      value={localValue}
      onChange={e => setLocalValue(e.target.value)}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          handleFilter?.(localValue, ...additionalParams)
        }
      }}
      sx={{
        width: '18.75rem',
        '& .MuiInputBase-input': {
          padding: '.75rem .75rem'
        },
        ...sx
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position='start'>
              <SearchIcon sx={{ color: 'custom.semiTransparentWhite' }} />
            </InputAdornment>
          ),
          endAdornment: localValue && (
            <InputAdornment position='end'>
              <IconButton
                onClick={handleClear}
                size='small'
                sx={{
                  color: 'custom.semiTransparentWhite',
                  '&:hover': {
                    color: 'text.primary'
                  }
                }}
              >
                <CloseIcon fontSize='small' />
              </IconButton>
            </InputAdornment>
          )
        }
      }}
    />
  )
}
